import styled from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"

const Input = styled.input`
  margin: 0 !important;
  border: none !important;
  outline: none !important;
  padding: 5px 0 !important;
  width: 100%;

  ${minWidthMedia.tablet`
      padding: 10px 0 !important;
    `}
`
export default Input
